




















import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import {
  UserApi, User, FilesApi, DocumentRequest,
  Documents, Document,
} from '@compassdigital/foodworks.ts.sdk';
import moment from 'moment';
import DocumentDropdown from '@/components/Stats/DocumentStats/DocumentDropdown/index.vue';
import DocumentTable from '@/components/Stats/DocumentStats/DocumentTable/index.vue';
import AppModule from '@/store/modules/app';
import StatsUtil from '@/util/StatsUtil';
import UserModule from '@/store/modules/user';
import ToastModule from '@/store/modules/toast';

@Component({
  components: {
    DocumentDropdown,
    DocumentTable,
  },
})

export default class DocumentStats extends Vue {
  public files: Documents [] = [];

  public docFiles: [] = [];

  public documentCounts: Documents[] = [];

  public marketsArr: [] = [];

  public selectDays: string = moment().subtract(7, 'days').format();

  public searchMarket: any = '';

  public loading: boolean = false;

  public dateRange: string = '';

  public mounted() {
    this.getAllDocs();
    this.accessAdminUser();
  }

  public beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      if (from.name === 'loading') {
        vm.getDocumentsList();
      } else {
        vm.getAllDocs();
      }
    });
  }

  @Watch('searchMarket', { immediate: true })
  marketSearched(val: any) {
    this.getFilteredDocs(val);
  }

  @Watch('selectDays', { immediate: true })
  daysSelected(val: any) {
    if (val) {
      this.dateRange = '';
      this.getFilteredDocs(this.searchMarket);
    }
  }

  @Watch('dateRange', { immediate: true })
  timeframeSelected(val: any) {
    if (val) {
      this.getFilteredDocs(this.searchMarket);
    }
  }

  public async getFilteredDocs(marketIds: Array<string>) {
    let doc;
    if (marketIds.length > 0) {
      const marketsS = marketIds;
      const filteredDocs = this.docFiles
        .filter((document: Document) => {
          if (document.marketId) {
            return marketsS.includes(document.marketId);
          }
          return null;
        });
      if (this.dateRange) {
        const prevDate = moment(this.dateRange.split(' - ')[0]).format('YYYY-MM-DD');
        const nextDate = moment(this.dateRange.split(' - ')[1]).format('YYYY-MM-DD');
        doc = await StatsUtil.getMappedDocs(
          filteredDocs,
          prevDate,
          nextDate,
          true,
        );
      } else {
        doc = await StatsUtil.getMappedDocs(
          filteredDocs,
          this.selectDays,
          '',
          false,
        );
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (this.dateRange) {
        const prevDate = moment(this.dateRange.split(' - ')[0]).format('YYYY-MM-DD');
        const nextDate = moment(this.dateRange.split(' - ')[1]).format('YYYY-MM-DD');
        doc = await StatsUtil.getMappedDocs(
          this.docFiles,
          prevDate,
          nextDate,
          true,
        );
      } else {
        doc = await StatsUtil.getMappedDocs(
          this.docFiles,
          this.selectDays,
          '',
          false,
        );
      }
    }
    this.files = doc.fetchedDocs;
    this.documentCounts = doc.countDocs;
  }

  public async getAllDocs() {
    const item = localStorage.getItem('documents');
    const fileRes = JSON.parse(item as any);
    this.docFiles = fileRes;
    if (fileRes) {
      const nextDate = '';
      const docs = await StatsUtil.getMappedDocs(
        (fileRes as any),
        this.selectDays,
        nextDate, false,
      );
      this.files = docs.fetchedDocs;
      this.documentCounts = docs.countDocs;
    } else {
      this.getDocumentsList();
    }
  }

  public async onChangeDates() {
    const nextDate = '';
    this.dateRange = '';
    const doc = await StatsUtil.getMappedDocs(this.docFiles,
      this.selectDays,
      nextDate,
      false);
    this.files = doc.fetchedDocs;
    this.documentCounts = doc.countDocs;
  }

  public async onChangeCustomDate(prevDate: string, NextDate: string) {
    const doc = await StatsUtil.getMappedDocs(this.docFiles, prevDate, NextDate, true);
    this.files = doc.fetchedDocs;
    this.documentCounts = doc.countDocs;
    this.dateRange = `${moment(prevDate).format('YYYY-MM-DD')} - ${moment(NextDate).format('YYYY-MM-DD')}`;
  }

  public setCustomDate(prevDate: string, NextDate: string) {
    this.dateRange = `${moment(prevDate).format('YYYY-MM-DD')} - ${moment(NextDate).format('YYYY-MM-DD')}`;
  }

  public async accessAdminUser() {
    this.loading = true;
    if (UserModule.currentRole === 'fw_manager'
      || UserModule.currentRole === 'fw_admin') {
      const marketsArrs = await StatsUtil.acessMarkets();
      if (marketsArrs) {
        this.marketsArr = (marketsArrs) as any;
        this.loading = false;
      }
    }
    this.loading = false;
    return null;
  }

  public async getDocumentsList() {
    const item = localStorage.getItem('documents');
    if (item) {
      localStorage.removeItem('documents');
    }
    try {
      this.loading = true;
      const api = new FilesApi(AppModule.apiConfig);
      const file = await api.getFiles();
      const { data } = file;
      const nextDates = '';
      if (file.data) {
        localStorage.setItem('documents', JSON.stringify(file.data));
        const doc = await StatsUtil.getMappedDocs((data as any), this.selectDays, nextDates, false);
        this.docFiles = (data) as any;
        this.files = doc.fetchedDocs;
        this.documentCounts = doc.countDocs;
      }
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        ToastModule.setToast({
          message,
          timeout: 5000,
        });
      }
    }
    this.loading = false;
  }
}
